import React, { useState } from "react";
import {
  IconButton,
  Card,
  CardActionArea,
  CardActions,
  CardContent,
  Tooltip,
} from "@mui/material";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import MoreHorizRoundedIcon from "@mui/icons-material/MoreHorizRounded";
import { t } from "i18next";

const CoreFolder = ({
  onGetFolder,
  nameFolder,
  icon,
  button = false,
  onDelete,
  onEdit,
}) => {
  const [show, setShow] = useState(false);

  return (
    <>
      <Card
        className="flex justify-center items-center text-center"
        sx={{
          width: "10rem",
          height: "10rem",
          borderRadius: "20px",
        }}
        elevation={4}
      >
        <div className="w-full h-full relative ">
          {button && (
            <CardActions className="w-full justify-end p-2 absolute z-10">
              <Tooltip title={t("Settings")}>
                <IconButton
                  className=""
                  size="small"
                  onClick={() => setShow(!show)}
                >
                  <MoreHorizRoundedIcon />
                </IconButton>
              </Tooltip>
            </CardActions>
          )}
          <CardActionArea
            disabled={show}
            className="w-full h-full"
            onClick={onGetFolder}
          >
            <CardContent className="p-0">
              {icon}
              <p className="m-0">{nameFolder}</p>
            </CardContent>
          </CardActionArea>
        </div>
      </Card>
      {show && (
        <div className="w-full flex justify-center pt-4">
          <Tooltip title={t("Edit")}>
            <IconButton onClick={onEdit}>
              <EditRoundedIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title={t("Delete")}>
            <IconButton onClick={onDelete} className="text-red-600">
              <DeleteRoundedIcon />
            </IconButton>
          </Tooltip>
        </div>
      )}
    </>
  );
};

export default CoreFolder;
